// import React, { useEffect } from "react";
// import Router from "./Router";
// import "./components/@vuexy/rippleButton/RippleButton";
// import axiosConfig from "../src/axiosConfig";
// import "react-perfect-scrollbar/dist/css/styles.css";
// import "prismjs/themes/prism-tomorrow.css";

// const App = (props) => {
//   // let isLoggedInBefore = localStorage.getItem("userData");
//   // let lastLoginTime = localStorage.getItem("loginTime");
//   useEffect(() => {
//     const isLoggedInBefore = localStorage.getItem("userData");
//     const lastLoginTime = localStorage.getItem("loginTime");
//     if (isLoggedInBefore) {
//       const TWO_HOURS_MS = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
//       const elapsedTime = Date.now() - parseInt(lastLoginTime, 10);

//       if (elapsedTime < TWO_HOURS_MS) {
//         //  setIsLoggedIn(true);
//       } else {
//         // Session expired, clear localStorage
//         localStorage.clear();
//         window.location.replace("/")
//       }
//     }
//   }, []);

//   // important function for token passing

//   // const requestInterceptor = axiosConfig?.interceptors.request.use(
//   //   (config) => {
//   //     // Get the token from your authentication mechanism (e.g., localStorage)
//   //     let token = JSON.parse(localStorage.getItem("userData"))?.token;

//   //     // If a token exists, add it to the request headers
//   //     if (token) {
//   //       config.headers.Authorization = `Bearer ${token}`;
//   //     }

//   //     return config;
//   //   },
//   //   (error) => {
//   //     // Handle request error
//   //     return Promise.reject(error);
//   //   }
//   // );
//   // const responseInterceptor = axiosConfig?.interceptors.response.use(
//   //   (config) => {
//   //     // Get the token from your authentication mechanism (e.g., localStorage)
//   //     let token = JSON.parse(localStorage.getItem("userData"))?.token;

//   //     // If a token exists, add it to the request headers
//   //     if (token) {
//   //       config.headers.Authorization = `Bearer ${token}`;
//   //     }

//   //     return config;
//   //   },
//   //   (error) => {
//   //     // Handle request error
//   //     return Promise.reject(error);
//   //   }
//   // );

//   return <Router />;
// };

// export default App;


import React, { useEffect, useRef } from "react";
import FooterNote from "../src/layouts/components/footer/FooterNote";
import Router from "./Router";
import "./components/@vuexy/rippleButton/RippleButton";
import axiosConfig from "../src/axiosConfig";
import "react-perfect-scrollbar/dist/css/styles.css";
import "prismjs/themes/prism-tomorrow.css";

const App = (props) => {

  const timerRef = useRef(null);
  const INACTIVITY_LIMIT = 5 * 60 * 1000; // ✅ 5 minutes inactivity limit

  // ✅ Helper: Call logout time API before auto logout
  const sendAutoLogoutLog = async () => {
    try {
      const loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      const userData = JSON.parse(localStorage.getItem("userData"));

      if (!loginInfo && !userData) return;

      const userId = loginInfo?.userId || userData?._id || userData?.Userinfo?._id;

      // ✅ Current date and time (not from loginInfo)
      // const now = new Date();
      // const date = now.toLocaleDateString();
      // const logOutTime = now.toLocaleTimeString();

      // const payload = {
      //   userId,
      //   date,
      //   logOutTime
      // };
      const now = new Date();

      // 🟦 Date — MM/DD/YYYY
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const dd = String(now.getDate()).padStart(2, "0");
      const yyyy = now.getFullYear();
      const date = `${mm}/${dd}/${yyyy}`;

      // 🟦 Time — 12-hour format with AM/PM
      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12 || 12;
      const logOutTime = `${hours}:${minutes}:${seconds} ${ampm}`;
      const sessionId =
        loginInfo?.sessionId ||
        userData?.sessionId ||
        localStorage.getItem("sessionId");
      const payload = {
        userId,
        date,
        logOutTime,
        sessionId
      };
      console.log("📤 Auto logout payload:", payload);
      await axiosConfig.post("/activity/update-logOutTime", payload);
      console.log("✅ Auto logout time saved successfully");
    } catch (error) {
      console.error("❌ Auto logout API error:", error.response?.data || error.message);
    }
  };

  // ✅ Reset Timer on Every Activity
  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(async () => {
      console.log("🕒 Auto logout triggered due to inactivity");

      // ✅ Step 1: Send logout log before clearing data
      await sendAutoLogoutLog();

      // ✅ Step 2: Clear storage and redirect
      localStorage.clear();
      window.location.href = "/#/";
    }, INACTIVITY_LIMIT);
  };

  // ✅ Start activity listeners once (global)
  useEffect(() => {
    const activityEvents = ["click", "mousemove", "keydown", "scroll", "touchstart"];

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer(); // Start timer immediately

    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      clearTimeout(timerRef.current);
    };
  }, []);

  // ✅ --------------- OLD 2-HOUR LOGIN CHECK ----------------
  useEffect(() => {
    const isLoggedInBefore = localStorage.getItem("userData");
    const lastLoginTime = localStorage.getItem("loginTime");

    if (isLoggedInBefore) {
      const TWO_HOURS_MS = 2 * 60 * 60 * 1000;
      const elapsedTime = Date.now() - parseInt(lastLoginTime, 10);

      if (elapsedTime >= TWO_HOURS_MS) {
        // ✅ Also send logout time when auto logout by time
        sendAutoLogoutLog();
        localStorage.clear();
        window.location.href = "/#/";
      }
    }
  }, []);
return (
  <>
    <Router />
    {/* <FooterNote />   👈 bas yaha lagana hai */}
  </>
);
};

export default App;
